import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { UserDetailPage } from './-components/UserDetailPage';

export const Route = createFileRoute('/_authenticated/users/$id')({
    context: ({ params }) => ({
        profileQuery: client.auth.users.profile.get.queryOptions(
            { params: { id: params.id } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.profileQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: UserDetailPage,
});
